export enum ExportAction {
  EXPORT_DEVICES = "exportDevices",
  EXPORT_ACTIVITY_LOGS = "exportActivityLogs",
  EXPORT_TICKETS = "exportTickets",
  EXPORT_PROTECTED_USERS = "exportProtectedUsers",
  EXPORT_TELEMETRY = "exportTelemetry",
}

export enum ExportFileExtension {
  CSV = "csv",
  ZIP = "zip",
}

export interface ExportListItem {
  id: string;
  type: ExportCategory;
  exportFileExtension: ExportFileExtension;
  exportName: string;
  creationTime: number;
  downloadLink: string;
}

export enum ExportCategory {
  ACTIVITY_LOGS = "activityLogs",
  DEVICES = "devices",
  USERS = "users",
  TICKETS = "tickets",
  TICKETS_MSP = "tickets_msp",
  TICKETS_MSP_SUMMARY = "tickets_summary_msp",
  DEVICES_MSP = "devices_msp",
  USERS_MSP = "users_msp",
  WORKSPACES_LIST = "workspaces",
  WORKSPACES_NOTIFICATIONS = "workspacesNotifications",
  WORKSPACES_SUMMARY = "workspacesSummary",
  DEVICES_AND_USERS_TREND = "usersAndDevicesTrendMsp",
  PHISHING_SIMULATION = "securityAwarenessSimulations",
  SECURITY_TRAINING = "securityAwarenessTraining",
  WARNING_EMAIL_EVENTS = "warningEmailEvents",
  EDR_TELEMETRY = "edrTelemetry",
}

export enum ExportChoice {
  ALL = "all",
  SPECIFIC = "specific",
}
